import React from 'react';
import { CustomComponentsProps } from '@website-editor/customComponents';
import { PhotoAddEdit } from './pages/PhotoAddEdit';
import { PHOTO_ACTIONS } from './Photo.constants';

interface PhotoNavigationsProps extends CustomComponentsProps {}

export const getPhotoNavigations = (props: PhotoNavigationsProps) => {
  const photoAdd = (
    <PhotoAddEdit
      type={PHOTO_ACTIONS.PHOTO_ADD}
      {...props}
    />
  );
  const photoEdit = (
    <PhotoAddEdit
      type={PHOTO_ACTIONS.PHOTO_EDIT}
      {...props}
      isEditMode
    />
  );
  return [photoAdd, photoEdit];
};
